import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const findByPostalCode = postalCode =>
  axios({
    method: 'post',
    url: `${publicAPI}/deliveryzone/findbypostalcode`,
    data: { postalCode },
  });
